"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMFWTheme = exports.defaultSettings = exports.strongShadows = exports.softShadows = void 0;
var color_1 = __importDefault(require("color"));
var typography_1 = require("./typography");
var core_1 = require("@material-ui/core");
//@ts-ignore
var lodash_es_1 = require("lodash-es");
exports.softShadows = [
    "none",
    "0 0 0 1px rgba(63,63,68,0.05), 0 1px 2px 0 rgba(63,63,68,0.15)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 2px 2px -2px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 4px 8px -2px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 5px 8px -2px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 6px 12px -4px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 7px 12px -4px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 6px 16px -4px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 7px 16px -4px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 8px 18px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 9px 18px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 10px 20px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 11px 20px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 12px 22px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 13px 22px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 14px 24px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 16px 28px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 18px 30px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 20px 32px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 22px 34px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 24px 36px -8px rgba(0,0,0,0.25)",
];
exports.strongShadows = [
    "none",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 3px 4px -2px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 2px 2px -2px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 3px 4px -2px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 3px 4px -2px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 4px 6px -2px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 4px 6px -2px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 4px 8px -2px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 5px 8px -2px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 6px 12px -4px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 7px 12px -4px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 6px 16px -4px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 7px 16px -4px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 8px 18px -8px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 9px 18px -8px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 10px 20px -8px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 11px 20px -8px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 12px 22px -8px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 13px 22px -8px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 14px 24px -8px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 16px 28px -8px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 18px 30px -8px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 20px 32px -8px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 22px 34px -8px rgba(0,0,0,0.50)",
    "0 0 1px 0 rgba(0,0,0,0.70), 0 24px 36px -8px rgba(0,0,0,0.50)",
];
var themeConfigs = function (t) { return [
    {
        name: t.type,
        palette: {
            type: t.type,
            action: {
                active: "rgba(255, 255, 255, 0.54)",
                selected: color_1.default(t.primary).alpha(0.65).string(),
                focus: "rgba(255, 255, 255, 0.12)",
            },
            background: {
                default: t.backgroundColor.default,
                dark: t.backgroundColor.dark,
                light: t.backgroundColor.light,
                contrast: t.backgroundColor.contrast,
            },
            primary: {
                main: t.primary,
            },
            secondary: {
                main: t.secondary,
                dark: color_1.default(t.secondary).alpha(0.65).string(),
            },
            text: {
                primary: t.text.primary,
                secondary: t.text.secondary,
            },
        },
        shadows: exports.strongShadows,
    },
]; };
var baseConfig = function (t) {
    return {
        direction: "ltr",
        typography: typography_1.typography(t),
        overrides: {
            MuiAlert: {
                standardInfo: {
                    color: themeConfigs(t)[0].palette.text.primary,
                    border: "3px solid " + themeConfigs(t)[0].palette.background.contrast,
                    backgroundColor: "none",
                },
                standardSuccess: {
                    color: themeConfigs(t)[0].palette.text.primary,
                    border: "1px solid " + themeConfigs(t)[0].palette.primary.main,
                    backgroundColor: "none",
                },
            },
            MuiDropzoneArea: {
                root: {
                    backgroundColor: themeConfigs(t)[0].palette.background.light,
                },
                text: {
                    color: themeConfigs(t)[0].palette.text.primary,
                },
            },
            MuiButton: {
                root: {
                    "&:disabled": {
                        color: themeConfigs(t)[0].palette.primary.main + "80",
                    },
                },
                contained: {
                    "&:disabled": {
                        backgroundColor: themeConfigs(t)[0].palette.background.light,
                        color: themeConfigs(t)[0].palette.text.secondary,
                    },
                },
                outlined: {
                    "&:disabled": {
                        border: "1px solid " + themeConfigs(t)[0].palette.primary.main + "80",
                        color: themeConfigs(t)[0].palette.primary.main + "80",
                    },
                },
            },
            MuiSwitch: {
                switchBase: {
                    color: themeConfigs(t)[0].palette.primary.main,
                    "&$checked": {
                        color: themeConfigs(t)[0].palette.primary.main,
                    },
                },
                thumb: {
                    backgroundColor: themeConfigs(t)[0].palette.text.primary,
                    "&$checked": {
                        backgroundColor: themeConfigs(t)[0].palette.primary.main,
                    },
                },
                track: {
                    backgroundColor: themeConfigs(t)[0].palette.background.contrast,
                    borderColor: themeConfigs(t)[0].palette.primary.main,
                },
            },
            MuiToggleButtonGroup: {
                root: {
                    backgroundColor: themeConfigs(t)[0].palette.primary.main,
                },
            },
            MuiToggleButton: {
                root: {
                    backgroundColor: themeConfigs(t)[0].palette.background.light,
                },
                label: {
                    color: themeConfigs(t)[0].palette.text.primary,
                },
            },
            MuiOutlinedInput: {
                notchedOutline: {
                    borderColor: themeConfigs(t)[0].palette.text.secondary + "80",
                },
                root: {
                    '&$disabled': {
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: themeConfigs(t)[0].palette.text.secondary,
                        },
                    },
                },
            },
            MuiFormControlLabel: {
                label: {
                    "&.Mui-disabled": {
                        color: themeConfigs(t)[0].palette.text.secondary,
                    },
                },
            },
            MuiInput: {
                underline: {
                    "&:before": {
                        borderBottom: "1px solid " + themeConfigs(t)[0].palette.text.primary,
                    },
                    "&:hover:not($disabled):before": {
                        borderBottom: "1px solid " + themeConfigs(t)[0].palette.text.primary,
                    },
                    "&$focused:before": {
                        borderBottom: "1px solid " + themeConfigs(t)[0].palette.text.primary,
                    },
                },
            },
            MuiInputBase: {
                input: {
                    "&:disabled": {
                        color: themeConfigs(t)[0].palette.text.secondary,
                    },
                },
            },
            MuiFilledInput: {
                root: {
                    backgroundColor: themeConfigs(t)[0].palette.background.contrast,
                    "&:hover": {
                        backgroundColor: themeConfigs(t)[0].palette.background.contrast,
                    },
                    "&.Mui-focused": {
                        backgroundColor: themeConfigs(t)[0].palette.background.contrast,
                    },
                    "&$error": {
                        backgroundColor: themeConfigs(t)[0].palette.background.contrast,
                    },
                    "&.Mui-disabled": {
                        backgroundColor: themeConfigs(t)[0].palette.background.contrast,
                        color: themeConfigs(t)[0].palette.text.primary,
                    },
                },
                underline: {
                    "&:before": {
                        borderBottom: "1px solid " + themeConfigs(t)[0].palette.text.primary,
                    },
                    "&:hover:not($disabled):before": {
                        borderBottom: "1px solid " + themeConfigs(t)[0].palette.text.primary,
                    },
                },
            },
            MuiTooltip: {
                tooltip: {
                    backgroundColor: themeConfigs(t)[0].palette.background.light,
                    color: themeConfigs(t)[0].palette.text.primary,
                    minWidth: 500,
                    fontSize: typography_1.typography(t).body1,
                },
            },
            MuiTypography: {
                root: {
                    primary: t.text.primary,
                },
            },
            MuiIcon: {
                filled: {
                    backgroundColor: themeConfigs(t)[0].palette.text.primary,
                },
            },
            MuiSvgIcon: {
                root: {
                    fill: themeConfigs(t)[0].palette.text.primary,
                },
            },
            MuiCompareArrows: {
                root: {
                    color: themeConfigs(t)[0].palette.text.primary,
                },
            },
            MuiChip: {
                variant: "outlined",
                size: "small",
                outlined: {
                    color: themeConfigs(t)[0].palette.text.primary,
                    borderColor: themeConfigs(t)[0].palette.text.secondary,
                },
                root: {
                    backgroundColor: themeConfigs(t)[0].palette.background.contrast,
                    color: themeConfigs(t)[0].palette.text.primary,
                    border: "1px solid " + themeConfigs(t)[0].palette.text.primary + "50",
                },
            },
            MuiAccordion: {
                root: {
                    backgroundColor: themeConfigs(t)[0].palette.background.light,
                    color: themeConfigs(t)[0].palette.primary.main,
                },
            },
            MuiAccordionSummary: {
                content: {
                    marginTop: 4,
                    marginBottom: 4,
                },
            },
            MuiTableRow: {
                hover: {
                    cursor: "pointer",
                },
            },
            MuiCard: {
                backgroundColor: themeConfigs(t)[0].palette.background.light,
            },
            MuiLinearProgress: {
                root: {
                    borderRadius: 3,
                    overflow: "hidden",
                },
            },
            MuiRating: {
                icon: {
                    marginRight: 4,
                },
                iconEmpty: {
                    fill: themeConfigs(t)[0].palette.text.secondary,
                },
                iconFilled: {
                    fill: themeConfigs(t)[0].palette.primary.main,
                },
            },
            MuiPaper: {
                root: {
                    backgroundColor: themeConfigs(t)[0].palette.background.default,
                },
            },
            MuiInputLabel: {
                filled: {
                    opacity: 0.5,
                },
                root: {
                    "&.Mui-disabled": {
                        color: themeConfigs(t)[0].palette.text.secondary,
                    },
                },
                shrink: {
                    "&.Mui-disabled": {
                        color: themeConfigs(t)[0].palette.text.primary + "80",
                    },
                },
            },
        },
        props: {
            MuiButtonBase: {
                disableRipple: true,
            },
            MuiTextField: {
                variant: "filled",
            },
            MuiTabs: {
                indicatorColor: "primary",
            },
        },
    };
};
exports.defaultSettings = {
    direction: "ltr",
    responsiveFontSizes: true,
    theme: "dark",
};
function createMFWTheme(settings, t) {
    if (settings === void 0) { settings = exports.defaultSettings; }
    var themeConfig = themeConfigs(t).find(function (theme) { return theme.name === settings.theme; });
    if (!themeConfig) {
        console.warn(new Error("The theme " + settings.theme + " is not valid"));
        themeConfig = themeConfigs(t)[0];
    }
    var theme = core_1.createTheme(
    //@ts-ignore
    lodash_es_1.merge({}, baseConfig(t), themeConfig, { direction: settings.direction }));
    if (settings.responsiveFontSizes) {
        theme = core_1.responsiveFontSizes(theme);
    }
    return theme;
}
exports.createMFWTheme = createMFWTheme;
//# sourceMappingURL=createMfwWebTheme.js.map